import { AcquirerTableDtoMapper } from "src/app/features/Acquirer/services/mappers/AcquirerTableDtoMapper";
import { AllowedProductProfileTableDtoMapper } from "src/app/features/AllowedProductProfile/services/mappers/AllowedProductProfileTableDtoMapper";
import { ApplicationProfileTableDtoMapper } from "src/app/features/ApplicationProfile/services/mappers/ApplicationProfileTableDtoMapper";
import { CardProfileTableDtoMapper } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/services/mappers/CardProfileTableDtoMapper";
import { PromptDataTableDtoMapper } from "src/app/features/ApplicationProfile/subFeatures/PromptData/services/mappers/PromptDataTableDtoMapper";
import { AppSchemaDtoToEntity } from "src/app/features/ApplicationSchema/services/mappers/AppSchemaDtoToEntity";
import { CampaignTableDtoMapper } from "src/app/features/Campaign/services/mappers/CampaignTableDtoMapper";
import { CardImplementationTableDtoMapper } from "src/app/features/CardImplementation/services/mappers/CardImplementationTableDtoMapper";
import { CardDefinitionTableDtoMapper } from "src/app/features/CardImplementation/subFeatures/CardDefinition/services/mappers/CardDefinitionTableDtoMapper";
import { CardAttributeTableDtoMapper } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/services/mappers/CardAttributeTableDtoMapper";
import { CardTypeTableDtoMapper } from "src/app/features/CardType/services/mappers/CardTypeTableDtoMapper";
import { ContractTableDtoMapper } from "src/app/features/Contract/services/mappers/ContractTableDtoMapper";
import { ContractProfileTableDtoMapper } from "src/app/features/ContractProfile/services/mappers/ContractProfileTableDtoMapper";
import { DataGroupTableDtoMapper } from "src/app/features/DataGroup/services/mappers/DataGroupTableDtoMapper";
import { DccProfileTableDtoMapper } from "src/app/features/DccProfile/services/mappers/DccProfileTableDtoMapper";
import { DealerChangeLogTableDtoMapper } from "src/app/features/DealerChangeLog/services/mappers/DealerChangeLogTableDtoMapper";
import { DynamicPropertyTableDtoMapper } from "src/app/features/DynamicProperty/services/mappers/DynamicPropertyTableDtoMapper";
import { DynamicPropertyGroupTableDtoMapper } from "src/app/features/DynamicPropertyGroup/services/mappers/DynamicPropertyGroupTableDtoMapper";
import { DynamicPropertyToGroupTableDtoMapper } from "src/app/features/DynamicPropertyGroup/services/mappers/DynamicPropertyToGroupTableDtoMapper";
import { EmvKernelProfileTableDtoMapper } from "src/app/features/EmvKernelProfile/services/mappers/EmvKernelProfileTableDtoMapper";
import { AidPreferenceTableDtoMapper } from "src/app/features/EmvKernelProfile/subFeatures/AidPreference/services/mappers/AidPreferenceTableDtoMapper";
import { CapKeyTableDtoMapper } from "src/app/features/EmvKernelProfile/subFeatures/CapKey/services/mappers/CapKeyTableDtoMapper";
import { EmvConfigurationTableDtoMapper } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/services/mappers/EmvConfigurationTableDtoMapper";
import { HostConfigurationTableDtoMapper } from "src/app/features/HostConfiguration/services/mappers/HostConfigurationTableDtoMapper";
import { HostProductCodeTableDtoMapper } from "src/app/features/HostProductCode/services/mappers/HostProductCodeTableDtoMapper";
import { HostResponseCodeTableDtoMapper } from "src/app/features/HostResponseCode/services/mappers/HostResponseCodeTableDtoMapper";
import { ManualDasConfigurationTableDtoMapper } from "src/app/features/ManualDasConfiguration/services/mappers/ManualDasConfigurationTableDtoMapper";
import { PosMappingTableDtoMapper } from "src/app/features/PosMapping/services/mappers/PosMappingTableDtoMapper";
import { PosTypeTableDtoMapper } from "src/app/features/PosType/services/mappers/PosTypeTableDtoMapper";
import { PrintingProfileTableDtoMapper } from "src/app/features/PrintingProfile/services/mappers/PrintingProfileTableDtoMapper";
import { ProductTableDtoMapper } from "src/app/features/Product/services/mappers/ProductTableDtoMapper";
import { ProductProfileTableDtoMapper } from "src/app/features/ProductProfile/services/mappers/ProductProfileTableDtoMapper";
import { PromptDataProfileTableDtoMapper } from "src/app/features/PromptDataProfile/services/mappers/PromptDataProfileTableDtoMapper";
import { SiteTableDtoMapper } from "src/app/features/Site/services/mappers/SiteTableDtoMapper";
import { SiteContractsTableMapper, SiteGroupTableDtoMapper } from "src/app/features/SiteGroup/services/mappers/SiteGroupTableDtoMapper";
import { TerminalTableDtoMapper } from "src/app/features/Terminal/services/mappers/TerminalTableDtoMapper";
import { TerminalImportLogTableDtoMapper } from "src/app/features/TerminalImportLog/services/mappers/TerminalImportLogTableDtoMapper";
import { TerminalProfileTableDtoMapper } from "src/app/features/TerminalProfile/services/mappers/TerminalProfileTableDtoMapper";
import { TerminalVersionTableDtoMapper } from "src/app/features/TerminalVersion/services/mappers/TerminalVersionTableDtoMapper";
import { UserLogTableDtoMapper } from "src/app/features/UserLog/services/mappers/UserLogTableDtoMapper";
import { VatCodeTableDtoMapper } from "src/app/features/VatCode/services/mappers/VatCodeTableDtoMapper";
import { VirtualSiteGroupTableDtoMapper } from "src/app/features/VirtualSiteGroup/services/mappers/VirtualSiteGroupTableDtoMapper";
import { FormConfigurationDtoToEntity } from "../../components/Form/services/mappers/FormConfigurationDtoToEntity";
import type { Dto } from "../types/be/Dto";
import type { ResourcePageDto } from "../types/be/ResourcePageDto";
import type { Entity } from "../types/fe";
import type { ResourcePageEntity } from "../types/fe/entities/ResourcePageEntity";
import { defaultMapper } from "./defaultMapper";
import { pageToListMapper } from "./pageToListMapper";

type DtoMapper = (input: Dto) => Entity;
type EntityMapper = (input: Entity) => Dto;
type PageDtoMapper = (input: ResourcePageDto<Dto>) => ResourcePageEntity<Entity>;

export type MapperType = DtoMapper | EntityMapper | PageDtoMapper;

type MapperMap = {
    [key: string]: MapperType;
};

export const mappers: MapperMap = {
    defaultMapper,
    pageToList: pageToListMapper,
    acquirersTableData: AcquirerTableDtoMapper,
    cardImplementationsTableData: CardImplementationTableDtoMapper,
    cardDefinitionsTableData: CardDefinitionTableDtoMapper,
    cardAttributesTableData: CardAttributeTableDtoMapper,
    contractsTableData: ContractTableDtoMapper,
    contractProfilesTableData: ContractProfileTableDtoMapper,
    dataGroupTableData: DataGroupTableDtoMapper,
    hostConfigurationsTableData: HostConfigurationTableDtoMapper,
    siteTableData: SiteTableDtoMapper,
    siteContractsTableData: SiteContractsTableMapper,
    siteGroupsTableData: SiteGroupTableDtoMapper,
    terminalTableData: TerminalTableDtoMapper,
    promptDataProfilesTableData: PromptDataProfileTableDtoMapper,
    emvKernelProfilesTableData: EmvKernelProfileTableDtoMapper,
    cardTypesTableData: CardTypeTableDtoMapper,
    campaignsTableData: CampaignTableDtoMapper,
    dynamicPropertiesTableData: DynamicPropertyTableDtoMapper,
    dynamicPropertyToGroupTableData: DynamicPropertyToGroupTableDtoMapper,
    dynamicPropertyGroupsTableData: DynamicPropertyGroupTableDtoMapper,
    terminalProfilesTableData: TerminalProfileTableDtoMapper,
    terminalVersionsTableData: TerminalVersionTableDtoMapper,
    applicationProfilesTableData: ApplicationProfileTableDtoMapper,
    applicationCardProfileTableData: CardProfileTableDtoMapper,
    applicationProfilePromptDatasTableData: PromptDataTableDtoMapper,
    capKeyTableData: CapKeyTableDtoMapper,
    aidPreferenceTableData: AidPreferenceTableDtoMapper,
    emvConfigurationsTableData: EmvConfigurationTableDtoMapper,
    formConfigurationDtoToFormConfigurationEntity: FormConfigurationDtoToEntity,
    appSchemaDtoToAppSchemaEntity: AppSchemaDtoToEntity,
    allowedProductsProfileTableData: AllowedProductProfileTableDtoMapper,
    posTypesTableData: PosTypeTableDtoMapper,
    posMappingsTableData: PosMappingTableDtoMapper,
    dealerChangeLogTableData: DealerChangeLogTableDtoMapper,
    productsTableData: ProductTableDtoMapper,
    productProfilesTableData: ProductProfileTableDtoMapper,
    hostProductCodeTableData: HostProductCodeTableDtoMapper,
    hostResponseCodeTableData: HostResponseCodeTableDtoMapper,
    printingProfilesTableData: PrintingProfileTableDtoMapper,
    dccProfilesTableData: DccProfileTableDtoMapper,
    vatCodesTableData: VatCodeTableDtoMapper,
    virtualSiteGroupsTableData: VirtualSiteGroupTableDtoMapper,
    manualDasConfigurationsTableData: ManualDasConfigurationTableDtoMapper,
    userLogsTableData: UserLogTableDtoMapper,
    terminalImportLogTableData: TerminalImportLogTableDtoMapper,
    // NEXT MAPPER
};

export const defaultMapperKey = "defaultMapper";
